import client from './client';

export interface SystemMetrics {
  cpu: {
    usage: number;
    cores: number;
    model: string;
    coreUsages: number[];
  };
  memory: {
    total: number;
    used: number;
    free: number;
    usagePercent: number;
  };
  disk: {
    total: number;
    used: number;
    free: number;
    usagePercent: number;
  };
  uptime: number;
  hostname: string;
  platform: string;
}

export const systemApi = {
  async getMetrics(): Promise<SystemMetrics> {
    const response = await client.get<{ data: SystemMetrics }>('/system/metrics');
    return response.data.data;
  },
};

export default systemApi;
